<template>
  <section class="main-content clearfix">
    <div class="right-container clearfix">
      <BreadCrumbs></BreadCrumbs>
      <tag v-if="noticeList && noticeList.length" v-model:categoryIds="categoryIds" :list="categoryList" @toggleCategory="toggleCategory"></tag>
      <!--div class="tag-list mrg-btm-20" v-if="noticeList && noticeList.length">
        <span class="tag" :class="{'active': categoryId === item.category.categoryId}" v-for="(item) in categoryList" :key="item.category.name" @click="toggleCategory(item.category.categoryId)">{{item.category.name}}</span>
      </div-->
      <div class="descript-container" v-if="noticeList && noticeList.length && computedCategoryList.length">
        共为您搜索到
        <template v-for="(item, index) in computedCategoryList">{{item.count}}个{{item.category.name}}{{index !== categoryList.length - 1 ? '，' : ''}}</template>
        相关结果
      </div>
      <List ref="list"></List>
    </div>
  </section>
</template>

<script>
import List from './list.vue'
import BreadCrumbs from './breadCrumbs.vue'
import {mapActions, mapMutations, mapState} from 'vuex'
import Tag from './tag.vue'
import {ref} from 'vue'
export default {
  name: '',
  data () {
    return {
      categoryId: 0
    }
  },
  computed: {
    ...mapState('rule', ['getChildrenFn', 'noticeList']),
    ...mapState('rule', {
      categoryList: 'ruleCounts'
    }),
    computedCategoryList () {
      return this.categoryList.slice(1)
    }
  },
  setup () {
    const categoryIds = ref([0])
    return {
      categoryIds
    }
  },
  mounted () {
    // this.$refs.lefter.promiseFn.then(() => {
    //   this.$refs.list.loadData(this.$refs.lefter.list)
    // })
    this.mountedFn()
  },
  methods: {
    mountedFn () {
      this.updatePage(this.$route.name)
      this.loadData()
    },
    toggleCategory (categoryId) {
      this.categoryId = categoryId
      this.$refs.list.loadData(categoryId)
    },
    loadData () {
      this.$refs.list.pageModal.pageNo = 1
      this.$refs.list.loadData()
    },
    ...mapMutations('rule', ['updatePhrase', 'updatePage']),
    ...mapActions('rule', ['getNoticeRootCategoryId', 'searchStatistics'])
  },
  watch: {
    $route (newVal, oldVal) {
      if (newVal.name !== 'Search') {
        return
      }
      console.log(111, newVal, oldVal)
      this.mountedFn()
    }
  },
  components: {
    List,
    BreadCrumbs,
    Tag
  }
}
</script>

<style lang="scss" scoped>

.main-content {
  padding: 10px 0;
  .right-container {
    margin-left: 0;
    background: #fff;
    padding-left: 30px;
    padding-right: 30px;
    min-height: 495px;
  }
}
.tag-list {
  .tag {
    display: inline-block;
    font-size: 12px;
    color: #222;
    line-height: 26px;
    font-weight: 400;
    background: #F3F4F5;
    border: 1px solid #F3F4F5;
    border-radius: 13px;
    padding: 0 12px;
    margin-right: 10px;
    cursor: pointer;
    min-width: 46px;
    text-align: center;
  }
  .active  {
    border-color: #F10180;
    color: #F10180;
    background: #fff;
  }
}
.descript-container  {
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  font-weight: 400;
  padding: 20px 0;
  padding-top: 0;
}
</style>
